import { z } from "zod";

export enum CommunityTier {
  basic = "basic",
  expansion = "expansion",
  growth = "growth",
}

export const communityTierEnum = z.nativeEnum(CommunityTier);
